import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { InputMaskDate } from '../../../Helpers/Formatters';
import { TextInput } from '../../../Helpers/Inputs';
import GenderButtons from '../../Common/SubComponents/GenderButtons';

export default function ChildInfoForm(props) {
    const onFieldChange = (field, value) => {
        // call onChange with the whole updated form
        props.onChange({ ...props.formState, [field]: value });
    };

    // manually call setValue for fields that don't play nice with react-hook-form register
    const handleValueChange = (field, value, longFieldName) => {
        onFieldChange(field, value);
        props.trigger(longFieldName);
    };

    return (
        <div>
            <Fragment>
                <h6>Dependent Child {props.index + 1}</h6>
                <div className='mb-3'>
                    <TextInput
                        name={`dependentChild[${props.index}].firstName`}
                        id={`dependentChild[${props.index}].firstName`}
                        label="First Name"
                        value={props.formState.firstName}
                        onChange={(e) => onFieldChange('firstName', e.target.value)}
                        inputProps={{
                            maxLength: 10,
                        }}
                    />
                </div>

                <div className='mb-3'>
                    <TextInput
                        name={`dependentChild[${props.index}].middleInitial`}
                        id={`dependentChild[${props.index}].middleInitial`}
                        label="Middle Initial"
                        value={props.formState.middleInitial}
                        onChange={(e) => onFieldChange('middleInitial', e.target.value)}
                        inputProps={{
                            maxLength: 4,
                        }}
                    />
                </div>

                <div className='mb-3'>
                    <TextInput
                        name={`dependentChild[${props.index}].lastName`}
                        id={`dependentChild[${props.index}].lastName`}
                        label="Last Name"
                        value={props.formState.lastName}
                        onChange={(e) => onFieldChange('lastName', e.target.value)}
                        inputProps={{
                            maxLength: 50,
                        }}
                    />
                </div>

                <div className='mb-3'>
                    <TextInput
                        name={`dependentChild[${props.index}].dateOfBirth`}
                        id={`dependentChild[${props.index}].dateOfBirth`}
                        label="Date of Birth"
                        value={props.formState.dateOfBirth}
                        onChange={(e) => handleValueChange('dateOfBirth', e.target.value, `dependentChild[${props.index}].dateOfBirth`)}
                        InputProps={{
                            inputComponent: InputMaskDate,
                        }}
                    />
                </div>

                <div className="m-0">
                    <GenderButtons
                        name={`dependentChild[${props.index}].gender`}
                        id={`dependentChild[${props.index}].gender`}
                        selectedGender={props.formState.gender}
                        onClickMale={() => handleValueChange('gender', 'Male', `dependentChild[${props.index}].gender`)}
                        onClickFemale={() => handleValueChange('gender', 'Female', `dependentChild[${props.index}].gender`)}
                    />
                </div>

                {/*props.showChildRemove && (
          <div className='mb-3'>
            <Button onClick={props.onRemove}>DELETE DEPENDENT CHILD</Button>
          </div>
        )*/}
            </Fragment>
        </div>
    );
}

ChildInfoForm.propTypes = {
    formState: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    index: PropTypes.number.isRequired,
};
